/**
 * Regular expression for strings consisting of date parts separated by dashes, consisting of years
 * that are 4 digits, months that are 2 digits, and dates that are 2 digits.
 * Examples:
 * '2020-01-31' => match
 * '2020-1-31' => no match
 */
export const dateStringRegEx = /^(\d{4})-(\d{2})-(\d{2})$/;
